export default __webpack_public_path__ + "static/media/service-moto-mobile.24c99f16.png";